import StructuredEventProperty from './StructuredEventProperty';

export default class AdClickEventProperty extends StructuredEventProperty {
  static override readonly type: number = 7;
  static override readonly label: string = 'AdClick event property';
  static override readonly indexProps = [
    { index: 1, label: 'targetUrl' },
    { index: 2, label: 'clickId' },
    { index: 3, label: 'costModel' },
    { index: 4, label: 'cost' },
    { index: 5, label: 'bannerId' },
    { index: 6, label: 'zoneId' },
    { index: 7, label: 'impressionId' },
    { index: 8, label: 'advertiserId' },
    { index: 9, label: 'campaignId' },
  ];
}
